import * as s from './styles';
import type { ITwoColumnL30R70 } from './types';

const TwoColumnL30R70 = ({
  childrenLeft,
  childrenRight,
  headline = 'Search by topic',
  ...props
}: ITwoColumnL30R70) => {
  if (!childrenLeft && childrenRight) return null;

  return (
    <s.StyledGrid>
      {headline && (
        <s.HeadlineContainer>
          <s.Headline colorVariant="dark" variant="h4">{headline}</s.Headline>
        </s.HeadlineContainer>
      )}
      <s.StyledTwoColumnL30R70 {...props}>
        <s.LeftColumn>{childrenLeft}</s.LeftColumn>
        <s.StyledDivider />
        <s.RightColumn>{childrenRight}</s.RightColumn>
      </s.StyledTwoColumnL30R70>
    </s.StyledGrid>
  );
};


export default TwoColumnL30R70;
